import React from "react";
import "@/App.css";
import Hero from "@/components/Hero";
import PhaseSection from "@/components/PhaseSection";
import ScrollProgress from "@/components/ScrollProgress";
import KeyboardHints from "@/components/KeyboardHints";
import Closing from "@/components/Closing";
import Footer from "@/components/Footer";
import { timelineData } from "@/data/timeline";
import useSnapNavigation from "@/hooks/useSnapNavigation";

function App() {
  useSnapNavigation(true);

  return (
    <div className="App bg-ink text-parchment min-h-screen">
      <ScrollProgress phases={timelineData} />
      <KeyboardHints />
      <Hero />
      {timelineData.map((phase, idx) => (
        <PhaseSection key={phase.id} phase={phase} index={idx} />
      ))}
      <Closing />
      <Footer />
    </div>
  );
}

export default App;
